module.exports = __webpack_public_path__ + "static/img/Caitlin-Foord.4784b4d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Caitlin-Foord.jpg
// module id = Zb49
// module chunks = 0